import React from "react";
import { CustomModal } from "../../components/customModal";
import { useDispatch, useSelector } from "react-redux";
import { useCssStyle } from "../../customHook/getCssStyle";
import { setShowLoginModal } from "../../Redux/Reducers/appConfigReducer";
import { useTranslation } from "react-i18next";
import { Text, View } from "react-native";
import CustomPressable from "../../components/customPressable/customPressable";
import AsyncStorage from "@react-native-async-storage/async-storage";


export const AppInfoModal = () => {

    const { t } = useTranslation();
    const getStyles = useCssStyle();
    const dispatch = useDispatch();

    const { appVersion, appBuildNumber } = useSelector(state => state.appConfigSlice);


    // we can improve this by making this async.
    const roomID = AsyncStorage.getItem("roomID");


    const handleCloseModal = () => {
        dispatch(setShowLoginModal(false));
    };


    return (
        <CustomModal onRequestClose={handleCloseModal} >
            <View style={getStyles(['loginModalContainer'])} id="loginModalContainer">
                <Text style={getStyles(['LoginModalTitle'])} id="LoginModalTitle">{t('guest_details.widget_title_logged_out_inroomapp')}</Text>
                <Text style={getStyles(['LoginModalSubTitle'])} id="LoginModalSubTitle">{roomID ? t('guest_details.widget_description_logged_out_inroomapp_registerd') : t('guest_details.widget_description_logged_out_inroomapp_notregisterd')}</Text>

                <View style={getStyles(['loginModalButtonContainer'])} id="loginModalButtonContainer">
                    <CustomPressable style={getStyles(['secondaryBtn'])} id="secondaryBtn" onPress={handleCloseModal}>
                        <Text style={getStyles(['secondaryBtnTxt'])} id="secondaryBtnTxt">{t('login.secondary_button_2')}</Text>
                    </CustomPressable>
                </View>

                <Text style={getStyles(['LoginModalVersionText'])} id="LoginModalVersionText">{`V${appVersion}(${appBuildNumber})`}</Text>
            </View>
        </CustomModal>
    )
}

